import { X } from 'lucide-react';


const CustomModal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-950 dark:border dark:border-gray-700 rounded-md shadow-xl p-2 w-full max-w-md mx-2 sm:mx-auto relative">
        <div className='flex justify-end items-center'> 
          <button
              onClick={onClose}
              className="group relative p-2 rounded-xl transition-all duration-200 hover:scale-105 active:scale-95"
              aria-label="Close modal"
              >
              <X 
                  size={20} 
                  className="text-gray-600 transition-colors duration-200" 
              />
              <div className=" inset-0 rounded-xl transition-all duration-200"></div>
          </button>
        </div> 
        {title && <h2 className="text-lg font-semibold mb-4">{title}</h2>}
        <div>{children}</div>
      </div>
    </div>
  );
};


export default CustomModal;
